export default __webpack_public_path__ + "static/media/java.3062d225.svg";